import React  from 'react';
//前言

const Enclosure02 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <h2><strong>董事长致词:</strong></h2><br/>
        <div style={{ textIndent: '2em' }}>
            <p>第二章节的内容显示</p>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
            <br/><br/>
        </div>
    </div>


export default Enclosure02;